import institutionAPI from 'services/institutionAPI'
import toast from 'utils/toast'
import {  AlertFilters } from 'AlertsOfVulnerability/types'

type Params = {
  filters: AlertFilters
}

export default async function readAlerts({ filters }: Params) {
  const response = await institutionAPI({
    method: 'POST',
    url: '/alert/case/cases',
    data: filters,
  })

  if (!response?.header?.success) {
    toast.error(response?.header?.message)
  }

  return response
}
